<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Our Team</h2>
          </header>
        </div>
        <div>
          <router-link to="/cms/team-detail" class="w3-button w3-teal w3-small w3-right vmiddle">
            <i class="fas fa-plus" style="margin-right:8px;"></i>New Item
          </router-link>
          <button class='w3-button w3-small w3-right vmiddle' style="margin-right:8px;" :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save</span><span v-if="saved">Saved</span></button>
        </div>
      </div>
      <div class="inputCard">
        <header>Options</header>
        <div class="content">
          <div class="cardRow w3-padding-8">
            <label>Layout</label>
            <div class="w3-right-align">
              <select class="w3-select w3-border" v-model="state.siteData.content.team.listType">
                <option value="default">Default</option>
                <option value="icons">Icons</option>
              </select>
            </div>
          </div>
          <div class="cardRow w3-padding-8">
            <label>Section Title</label>
            <input v-model="state.siteData.content.team.title" placeholder="Our Team" class="w3-input w3-border" />
          </div>
          <div class="cardRow w3-padding-8">
            <label>Center Title</label>
            <div class="w3-right-align">
              <label class="switch">
                <input type="checkbox" v-model="state.siteData.content.team.centerTitle">
                <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="inputCard">
        <header>Team Members</header>
        <div class="content">
          <div class="teamContentGrid w3-padding-8" v-for="(item, index) in state.siteData.content.team.items" :key="index">
            <div class="teamName">
              <template v-if="item.image">
                <img :src="item.image.src" :alt="item.image.alt" style="width:100%;" />
              </template>
              <template v-else>
                <img src="https://levelsevenstudio.com/frontend/img/team/team-22.jpg" alt="team image" style="width:100%;" />
              </template>
            </div>
            <div class="teamText w3-padding-8">
              <template v-if="item.name && item.name !== ''">{{item.name}}<br/></template>
              {{item.title}}
              <template v-if="!item.name || item.name === ''"><template v-if="item.phone && item.phone !== ''"><br/>{{item.phone}}</template></template>
            </div>
            <div class="buttons">
              <router-link tag="button" :to="'/cms/team-detail/' + item.url" class="w3-button w3-small w3-teal">Edit</router-link>
              <button class="w3-button w3-small w3-red" @click="deleteItem(item.url)">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsteam',
  data() {
    return {
      state: dataStore.state,
      saving: false,
      saved: false
    }
  },
  methods: {
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deleteItem(url) {
      let itemIndex = this.state.siteData.content.team.items.findIndex(savedItem => savedItem.url === url)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.content.team.items[itemIndex].title + '?')) {
          this.state.siteData.content.team.items.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    }
  }
}
</script>

<style scoped>
  .teamContentGrid {display:grid; grid-template-columns: 100px 1fr 130px; grid-gap: 8px; border-bottom:1px solid #ccc;}
  .teamContentGrid:last-child {border-bottom:0;}
  .buttons {text-align: right;}
  .inputCard header {text-align: left; padding-left:12px;}
@media screen and (max-width:993px) {
  .teamTitle {font-size:10pt;}
  .teamMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
  .teamGrid {display:grid; grid-template-columns: 125px 1fr; grid-gap: 8px;}
  .teamContentGrid {grid-template-columns: 1fr;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsTeam.vue